import { NftEnumType } from "@multiversx/sdk-dapp/types/tokens.types";
import { isDev } from "config";

export interface NftInfoType {
  nonce: number,
  name: string,
  url: string,
}

export interface CollectionSimpleType {
  logo: string,
  name: string,
  type: NftEnumType,
}

export const PAGE_SIZE = 12;
export const XOXNO_IMAGE_URL = 'https://media.xoxno.com/nftmedia/';
export const XOXNO_API_URL = isDev ? 'https://api-dev.xoxno.com/searchNFTs/' : 'https://proxy-api.xoxno.com/searchNFTs/';
export const XOXNO_FILTER = `{"filters":{"marketplace":["XO"],"onSale":true,"auctionTypes":["Nft","SftOnePerPayment"],"tokens":["EGLD"],"attributes":[],"range":{"min":0,"max":9007199254740991,"type":"saleInfoNft/min_bid_short"}},"name":"","orderBy":["saleInfoNft/min_bid_short asc"],"collection":"%s","top":${PAGE_SIZE},"select":["metadata/rarity/rank","metadata/attributes","name","onSale","saleInfoNft","royalties","identifier","collection","url","nonce","originalMedia/contentType","wasProcessed","avifUrl","webpUrl","type"],"skip":%d}`;

export const AMM_COLLECTION_IDS = isDev ? [
  'GRDF-dfbc67',
  'CITY-47279e',
  'FCS-12ed15',
] : [
  'EPUNKS-46b186',
  'EAPES-8f3c1f',
  'COMBEYS-bc640d',
  'GSPACEAPE-08bc2b',
  'ETHOS-205078',
  'UGP-e71806',
  'SFITLEGEND-5da9dd',
  'DRIFTERS-efd96c',
  'SOULZ-9406f0',
  'GIANTS-93cadd',
  'COW-cd463d',
  'BAXC-cdf74d',
  'GNOGONS-73222b',
  'QUACK-f01e02',
  'BHAGENTS-3e9010',
  'MAIARPUNKS-3db7e8',
    'CITYNFT-26cded',
    'EPUNKSDAO-cd4a0a',
    'QWTCARDS-17f15b',
    'QWTCOINS-27203b',
    'ZOIDSTERS-9121a9',
    'MAFIA-bd0abc',
    'GUARDIAN-3d6635',
    'MOS-b9b4b2',
    'GNOGEN-8156fb',
    'SRB-61daf7',
    'NFTIM-4586ac',
    'INNOVATOR-fca3a7',
    'OAG-0eaf3b',
    'HSWOLF-76e8bf',
    'LIONS-d7a901',
    'LIGHTNINGB-496265',
    'VTWO-8d2640',
    'FTOONS-b68710',
    'OGS-3f1408',
    'BRICKS-8b0bcb',
    'WHALEYS-24a32a',
    'RAJI-c0017b',
    'SUBJECTX-2c184d',
    'DCLUB-b0ddcb'






















];

export const COLLECTIONS_MAP: Record<string, CollectionSimpleType> = isDev ? {
  'GRDF-dfbc67': {
    logo: 'https://media.xoxno.com/collectionprofile/GRDF-dfbc67/profilePicture.webp',
    name: 'GRDF',
    type: NftEnumType.NonFungibleESDT,
  },
  'CITY-47279e': {
    logo: 'https://media.xoxno.com/collectionprofile/CITY-47279e/profilePicture.webp',
    name: 'Cyber',
    type: NftEnumType.SemiFungibleESDT,
  },
  'FCS-12ed15': {
    logo: 'https://media.xoxno.com/collectionprofile/FCS-12ed15/profilePicture.webp',
    name: 'FCS',
    type: NftEnumType.NonFungibleESDT,
  },
  'EAPES-aa2fdf': {
    logo: 'https://media.xoxno.com/collectionprofile/EAPES-8f3c1f/profilePicture.webp',
    name: 'ElrondApes',
    type: NftEnumType.NonFungibleESDT,
  },
} : {
  'EPUNKS-46b186': {
    logo: 'https://media.xoxno.com/collectionprofile/EPUNKS-46b186/profilePicture.webp',
    name: 'ElrondPunks',
    type: NftEnumType.NonFungibleESDT,
  },
  'EAPES-8f3c1f': {
    logo: 'https://media.xoxno.com/collectionprofile/EAPES-8f3c1f/profilePicture.webp',
    name: 'ElrondApes',
    type: NftEnumType.NonFungibleESDT,
  },
  'COMBEYS-bc640d': {
    logo: 'https://media.xoxno.com/collectionprofile/COMBEYS-bc640d/profilePicture.webp',
    name: 'Combeys',
    type: NftEnumType.NonFungibleESDT,
  },
  'GSPACEAPE-08bc2b': {
    logo: 'https://media.xoxno.com/collectionprofile/GSPACEAPE-08bc2b/profilePicture.webp',
    name: 'GenesisSpaceApes',
    type: NftEnumType.NonFungibleESDT,
  },
  'CEA-2d29f9': {
    logo: 'https://media.xoxno.com/collectionprofile/CEA-2d29f9/profilePicture.webp',
    name: 'GenCantinaElrondApes',
    type: NftEnumType.NonFungibleESDT,
  },
  'SFITLEGEND-5da9dd': {
    logo: 'https://media.xoxno.com/collectionprofile/SFITLEGEND-5da9dd/profilePicture.webp',
    name: 'SFITLEGENDS',
    type: NftEnumType.NonFungibleESDT,
  },
  'BAXC-cdf74d': {
    logo: 'https://media.xoxno.com/collectionprofile/BAXC-cdf74d/profilePicture.webp',
    name: 'Bored Ape X Club',
    type: NftEnumType.NonFungibleESDT,
  },
  'GNOGONS-73222b': {
    logo: 'https://media.elrond.com/nfts/asset/QmdCEkyaafqZgmeydXfyWmB71qhHf1WSyGmRtv1SzDFq31/3784.png',
    name: 'GNOGONS',
    type: NftEnumType.NonFungibleESDT,
  },
  'MAFIA-bd0abc': {
    logo: 'https://media.xoxno.com/collectionprofile/MAFIA-bd0abc/profilePicture.webp',
    name: 'MAFIA',
    type: NftEnumType.NonFungibleESDT
  },
  'COW-cd463d': {
    logo: 'https://media.xoxno.com/collectionprofile/COW-cd463d/profilePicture.webp',
    name: 'CowCow',
    type: NftEnumType.NonFungibleESDT,
  },

  'DRIFTERS-efd96c': {
    logo: 'https://media.xoxno.com/collectionprofile/DRIFTERS-efd96c/profilePicture.webp',
    name: 'DRIFTERS',
    type: NftEnumType.NonFungibleESDT,
  },
  'SOULZ-9406f0': {
    logo: 'https://media.xoxno.com/collectionprofile/SOULZ-9406f0/profilePicture.webp',
    name: 'SOULZ OF ZION',
    type: NftEnumType.NonFungibleESDT,
  },
  'GIANTS-93cadd': {
    logo: 'https://media.xoxno.com/collectionprofile/GIANTS-93cadd/profilePicture.webp',
    name: 'Giants',
    type: NftEnumType.NonFungibleESDT,
  },
  'UGP-e71806': {
    logo: 'https://media.xoxno.com/collectionprofile/UGP-e71806/profilePicture.webp',
    name: 'uPark Genesis Pass - UGP',
    type: NftEnumType.NonFungibleESDT,
  },
  'BHAGENTS-3e9010': {
    logo: 'https://media.xoxno.com/collectionprofile/BHAGENTS-3e9010/profilePicture.webp',
    name: 'BHAGENTS',
    type: NftEnumType.NonFungibleESDT,
  },
  'QUACK-f01e02': {
    logo: 'https://media.xoxno.com/collectionprofile/QUACK-f01e02/profilePicture.webp',
    name: 'ElrondDucks',
    type: NftEnumType.NonFungibleESDT,
  },
  'MAIARPUNKS-3db7e8': {
    logo: 'https://aero.mypinata.cloud/ipfs/QmR6H6ei2kj7WeaMv8b6tEEhZJLMgsGU9wsXFGDgM6WZDn/1636296449.png',
    name: 'MaiarPunks',
    type: NftEnumType.NonFungibleESDT,
  },
  'ETHOS-205078': {
    logo: 'https://media.xoxno.com/collectionprofile/ETHOS-205078/profilePicture.webp',
    name: 'ETHOS by Calileo',
    type: NftEnumType.NonFungibleESDT,
  },
  'CITYNFT-26cded': {
    logo: 'https://media.xoxno.com/collectionprofile/CITYNFT-26cded/profilePicture.webp',
    name: 'CityNFT',
    type: NftEnumType.NonFungibleESDT,
  },
  'QWTCOINS-27203b': {
    logo: 'https://media.elrond.com/nfts/asset/QmP4K4Mp1sLdipRyttx7vo6RczrDQn9MtSALn9ZGCUt3ud/QwtCoinONE.mp4',
    name: 'QoWattCoins',
    type: NftEnumType.SemiFungibleESDT,
  },
  'EPUNKSDAO-cd4a0a': {
    logo: 'https://media.xoxno.com/collectionprofile/EPUNKSDAO-cd4a0a/profilePicture.webp',
    name: 'EPUNKSDAO',
    type: NftEnumType.SemiFungibleESDT,
  },
  'QWTCARDS-17f15b': {
    logo: 'https://media.xoxno.com/collectionprofile/QWTCARDS-17f15b/profilePicture.webp',
    name: 'QoWattCards',
    type: NftEnumType.SemiFungibleESDT,
  },
  'ZOIDSTERS-9121a9': {
    logo: 'https://media.xoxno.com/collectionprofile/ZOIDSTERS-9121a9/profilePicture.webp',
    name: 'Zoidsters',
    type: NftEnumType.NonFungibleESDT,
  },
  'GUARDIAN-3d6635': {
    logo: 'https://media.xoxno.com/collectionprofile/GUARDIAN-3d6635/profilePicture.webp',
    name: 'Aquaverse',
    type: NftEnumType.NonFungibleESDT,
  },
  'MOS-b9b4b2': {
    logo: 'https://media.xoxno.com/collectionprofile/MOS-b9b4b2/profilePicture.webp',
    name: 'Stramosi',
    type: NftEnumType.NonFungibleESDT,
  },
  'GNOGEN-8156fb': {
    logo: 'https://media.xoxno.com/collectionprofile/GNOGEN-8156fb/profilePicture.webp',
    name: 'EMIDASGENESIS',
    type: NftEnumType.NonFungibleESDT,
  },
  'SRB-61daf7': {
    logo: 'https://media.xoxno.com/collectionprofile/SRB-61daf7/profilePicture.webp',
    name: 'SuperRareBears',
    type: NftEnumType.NonFungibleESDT,
  },
  'INNOVATOR-fca3a7': {
    logo: 'https://media.elrond.com/nfts/asset/QmQrdQyYSPPqGTQFrADjVA3pZUHQgkgdEddHAWRbMgR196/325.png',
    name: 'Drifters [INNOVATORS]',
    type: NftEnumType.NonFungibleESDT,
  },
  'OAG-0eaf3b': {
    logo: 'https://media.xoxno.com/collectionprofile/OAG-0eaf3b/profilePicture.webp',
    name: 'OddApesGang',
    type: NftEnumType.NonFungibleESDT,
  },
  'NFTIM-4586ac': {
    logo: 'https://media.xoxno.com/collectionprofile/NFTIM-4586ac/profilePicture.webp',
    name: 'NFTim',
    type: NftEnumType.NonFungibleESDT,
  },
  'HSWOLF-76e8bf': {
    logo: 'https://media.xoxno.com/collectionprofile/HSWOLF-76e8bf/profilePicture.webp',
    name: 'High Street Wolf Society',
    type: NftEnumType.NonFungibleESDT,
  },
  'LIONS-d7a901': {
    logo: 'https://media.xoxno.com/collectionprofile/LIONS-d7a901/profilePicture.webp',
    name: 'ElrondLionsClub',
    type: NftEnumType.NonFungibleESDT,
  },
  'LIGHTNINGB-496265': {
    logo: 'https://media.xoxno.com/collectionprofile/LIGHTNINGB-496265/profilePicture.webp',
    name: 'Lightning Bolts',
    type: NftEnumType.NonFungibleESDT,
  },
  'VTWO-8d2640': {
    logo: 'https://media.xoxno.com/collectionprofile/VTWO-8d2640/profilePicture.webp',
    name: 'VALIDATORSV2',
    type: NftEnumType.NonFungibleESDT,
  },
  'FTOONS-b68710': {
    logo: 'https://media.xoxno.com/collectionprofile/FTOONS-b68710/profilePicture.webp',
    name: 'Fightoons',
    type: NftEnumType.NonFungibleESDT,
  },
  'OGS-3f1408': {
    logo: 'https://media.xoxno.com/collectionprofile/OGS-3f1408/profilePicture.webp',
    name: 'SubcarpatiOGs',
    type: NftEnumType.NonFungibleESDT,
  },
  'BRICKS-8b0bcb': {
    logo: 'https://media.xoxno.com/collectionprofile/BRICKS-8b0bcb/profilePicture.webp',
    name: 'MetaBricks',
    type: NftEnumType.NonFungibleESDT,
  },
  'WHALEYS-24a32a': {
    logo: 'https://media.xoxno.com/collectionprofile/WHALEYS-24a32a/profilePicture.webp',
    name: 'Whaleys',
    type: NftEnumType.NonFungibleESDT,
  },
  'RAJI-c0017b': {
    logo: 'https://media.xoxno.com/collectionprofile/RAJI-c0017b/profilePicture.webp',
    name: 'DriftersRaji',
    type: NftEnumType.NonFungibleESDT,
  },

  'SUBJECTX-2c184d': {
    logo: 'https://media.xoxno.com/collectionprofile/SUBJECTX-2c184d/profilePicture.webp',
    name: 'SubjectX',
    type: NftEnumType.NonFungibleESDT,
  },


  'DCLUB-b0ddcb': {
    logo: 'https://media.xoxno.com/collectionprofile/DCLUB-b0ddcb/profilePicture.webp',
    name: 'Divergent Club',
    type: NftEnumType.NonFungibleESDT,
  },
};
